/**
 * Field metrics from the Figma text field: 16px inset for the label and value, and a dashed
 * disabled outline drawn inside the box (the theme adds it as a border, which makes disabled
 * fields 2px taller than the rest). Spread into the `sx` of a container whose fields should
 * follow the new design; the global theme is left as is.
 */
export const FIELD_METRICS_SX = {
    "& .MuiFilledInput-root .MuiFilledInput-input": { pl: "16px" },
    "& .MuiInputLabel-filled": { transform: "translate(16px, 16px) scale(1)" },
    "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
        transform: "translate(16px, 6px) scale(0.75)",
    },
    "& .MuiFilledInput-root.Mui-disabled": {
        border: "none",
        outline: "1px dashed rgba(145, 158, 171, 0.2)",
        outlineOffset: "-1px",
    },
};
